import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UserLayout from '@components/layout/UserLayout.tsx';
import ShoppingListDetailPage from '@features/shopping-list/detail/ShoppingListDetailPage.tsx';

const paramsSchema = z.object({
  shoppingListId: z.coerce.number(),
});
export const Route = createFileRoute('/c/$orgId/$portalId/shopping-list/$shoppingListId')({
  params: {
    parse: v => paramsSchema.parse(v),
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { shoppingListId } = Route.useParams();

  return (
    <UserLayout>
      <ShoppingListDetailPage shoppingListId={shoppingListId} />
    </UserLayout>
  );
}
